import doc                                     from '@widesk-core/decorators/doc';
import model                                   from '@widesk-core/decorators/model';
import AbstractWebsiteEntertainmentStatusModel from './AbstractWebsiteEntertainmentStatusModel';

@doc.urnResource('website_entertainment_status')
@model.cacheDuration()
export default class WebsiteEntertainmentStatusModel extends AbstractWebsiteEntertainmentStatusModel {
	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
